/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import {
    Button,
    Dropdown,
} from '@wordpress/components';
import {
    BlockControls,
    __experimentalLinkControl as LinkControl,
} from '@wordpress/block-editor';
import { link } from '@wordpress/icons';

const Controls = ({
    attributes,
    setAttributes
}) => {
    const { linkUrl, linkTarget } = attributes;

    return (
        <BlockControls>
            <Dropdown
                className="th-link-button"
                contentClassName="my-popover-content-classname"
                popoverProps={{ placement: 'bottom-start' }}
                renderToggle={({ isOpen, onToggle }) => (
                    <Button
                        variant="primary"
                        onClick={onToggle}
                        aria-expanded={isOpen}
                        icon={link}
                    >
                        {__("Add/Edit Link", "your-textdomain")}
                    </Button>
                )}
                renderContent={() => (
                    <LinkControl
                        searchInputPlaceholder={__("Search or type URL", "your-textdomain")}
                        value={{ url: linkUrl, opensInNewTab: linkTarget === '_blank' }}
                        settings={[
                            {
                                id: 'opensInNewTab',
                                title: __("Open in new tab", "your-textdomain"),
                            },
                        ]}
                        onChange={(newLink) => setAttributes({
                            linkUrl: newLink.url,
                            linkTarget: newLink.opensInNewTab ? '_blank' : '_self',
                        })}
                        withCreateSuggestion
                        createSuggestion={(inputValue) => setAttributes({
                            linkUrl: inputValue,
                            linkTarget: '_self'
                        })}
                        createSuggestionButtonText={(newValue) => `${__("New:")} ${newValue}`}
                    />
                )}
            />
        </BlockControls>
    );
};

export default Controls;